<script setup>
import {
  inject, onMounted, ref, watch,
} from 'vue';

const I18n = inject('I18n');

const props = defineProps({
  perfilSalida: { type: Object, required: true },
});

const chart = ref();

/* global Chart */
function pintarChart() {
  if (!chart.value) {
    return;
  }

  const ctx = chart.value.getContext('2d');
  const labels = [];
  const datasetAlumno = [];
  const datasetGrupo = [];
  props.perfilSalida.competencias_clave.forEach((cc) => {
    labels.push(cc.definicion.codigo);
    datasetAlumno.push(cc.calificacion.valores_para_formula?.principal || 0);
    datasetGrupo.push(cc.media_grupo || 0);
  });

  // eslint-disable-next-line no-new
  new Chart(ctx, {
    type: 'radar',
    data: {
      labels,
      datasets: [
        {
          label: I18n.t('Alumno'),
          data: datasetAlumno,
        },
        {
          label: I18n.t('Media_grupo'),
          data: datasetGrupo,
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgb(255, 99, 132)',
          pointBackgroundColor: 'rgb(255, 99, 132)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(255, 99, 132)',
        },
      ],
    },
    options: {
      scale: {
        ticks: {
          beginAtZero: true,
          max: 10,
          min: 0,
          stepSize: 2,
        },
      },
    },
  });
}

watch(() => props.perfilSalida, () => {
  pintarChart();
});

onMounted(() => {
  pintarChart();
});
</script>

<template>
  <canvas ref="chart"></canvas>
</template>
<style lang="scss" scoped>

</style>
